<template>
  <!--begin::Card-->
  <div class="card">
    <!--begin::Card body-->
    <div class="card-body">
    <nav class="navbar navbar-light" style="background-color: #e3f2fd;">
        <div class="container-fluid">
          <a class="navbar-brand"> {{nameNavbar}}</a>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
              <!-- <li class="nav-item">
                <a class="nav-link active" aria-current="page" >Añadir Docentes</a>
              </li> -->
              <!--  Asistencia Psicológica -->
              <!-- <li class="nav-item dropdown">
                <a 
                  class="nav-link dropdown-toggle" 
                  id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  Asistencia Psicológica
                </a>
                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li><a class="dropdown-item cursor_pointer" @click="addTeacher">Añadir Asistencia Prsicológica</a></li>
                  <li><a class="dropdown-item cursor_pointer" @click="listTeachers">Lista Asistencias Psicólogicas</a></li>
                  <li><hr class="dropdown-divider"></li>
                  <li><a class="dropdown-item" href="#">Something else here</a></li>
                </ul>
              </li> -->
              <!-- Asistencia Psicológica a Privados de Libertad -->
              <li class="nav-item dropdown cursor_pointer">
                <a class="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  Asistencia Psicológica a Privados de Libertad
                </a>
                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                  <li><a class="dropdown-item" @click="addPplAttendance">Añadir Asistencia a PPL</a></li>
                  <li><a class="dropdown-item" @click="listPplAttendance">Lista Asistencias Realizadas</a></li>
                  <!-- <li><hr class="dropdown-divider"></li>
                  <li><a class="dropdown-item" href="#">Something else here</a></li> -->
                </ul>
              </li>
              <li><hr class="dropdown-divider"></li>
            </ul>
          </div>
        </div>
      </nav>
      <!-- agregar asistencias Psicológicas -->
      <!-- <div v-if="isAddingPsychologicattendance" class="row p-3">
       <h4>{{!isAddingOtherAttendance?'Registro de Asistencia Psicológica':'Adición de Asistencia Psicológica'}}</h4>
        <div class="row">
          <div class="col-md-6 p-2">
            <label for="" required>Nombre Asistencia Primaria:</label>
            <input 
              type="text"
              class="form-control"
              v-uppercase
              :disabled="isAddingOtherAttendance"
              v-model.trim="statePsychologicAttendance[0].asistencia_primaria"
            >
          </div>
          <div class="col-md-1 py-8">
            <button 
              class="btn btn-primary" 
              :disabled="!attendance.asistencia_principal"
               @click="addAttendanceToArray"
            > Añadir Asistencia Primaria
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 p-2">
            <label for="" required>Nombre Sub-asistencia:</label>
            <input 
              type="text" 
              class="form-control"
              v-uppercase
              :disabled="isAddingOtherAttendance"
              v-model.trim="statePsychologicAttendance[0].sub_asistencia"
            >
          </div>
          <div class="col-md-1 py-8">
            <button 
              class="btn btn-primary" 
              :disabled="!attendance.asistencia_principal"
               @click="addAttendanceToArray"
            > Añadir Sub-asistencia
            </button>
          </div>
        </div>
        <hr class="my-5">
        <div class="row">
          <div class="col-md-6 p-2">
            <label for="" required>Nombre asistencia:</label>
            <input 
              type="text" 
              class="form-control"
              v-uppercase
              v-model.trim="attendance.asistencia_principal"
            >
          </div>
          <div class="col-md-1 py-8">
            <button 
              class="btn btn-primary" 
              :disabled="!attendance.asistencia_principal"
               @click="addAttendanceToArray"
            > Añadir Asistencia
            </button>
          </div>
        </div>
        <div class="row table-responsive">
          <table class="table">
           <thead>
             <tr>
               <th scope="col">Nombre Asistencia Primaria</th>
               <th scope="col">Nombre Sub-asistencia</th>
               <th scope="col">Nombre Asistencia</th>
               <th scope="col">Acciones</th>
             </tr>
           </thead>
           <tbody>
             <tr v-if="statePsychologicAttendance[0].asistencias.length==0">
               <td colspan="6">
                 No existen registros de profesores.
               </td>
             </tr>
             <tr v-for="(asistencia, index) in statePsychologicAttendance[0].asistencias" :key="index">
               <td style="text-align:center" v-if="index === 0" :rowspan="statePsychologicAttendance[0].asistencias.length">{{ statePsychologicAttendance[0].asistencia_primaria }}</td>
               <td v-if="index === 0" :rowspan="statePsychologicAttendance[0].asistencias.length">{{ statePsychologicAttendance[0].sub_asistencia }}</td>
               <td>{{ asistencia.asistencia_principal }}</td>
               <td data-label="Acciones">
                <div class="icon-container">
                 <i class="fa fa-edit fa-2x" style="color:skyblue" title="editar" @click="editAttendance(asistencia, index)"></i>&nbsp;
                </div>
                <div class="icon-container">
                 <i class="fa fa-trash fa-2x" style="color:red" title="eliminar" @click="deleteattendance(index)"></i>
                </div>
               </td>
             </tr>
           </tbody>
          </table>
        </div>
        <p class="p-2" align="right">
            <button
              class="btn btn-danger"
              @click="clearFormAttendanceForm()"
            >
              Limpiar
            </button>&nbsp;
            <button
              v-if="!isLoading"
              class="btn btn-success"
              @click="registerAttendance()"
            >
              {{!isAddingOtherAttendance?'Registrar Asistencia Psicológica':'Agregar Asistencia Psicológica'}}
            </button>
            <button
                v-else
                class="btn btn-primary"
                disabled
              >
                Por favor espere ...
              </button>
          </p>
      </div> -->
      <!-- lista de asistencias Psicológicas -->
      <!-- <div v-if="isListTeachers" class="row p-3">
      <h4>Lista de Profesores</h4>
        <div class="row table-responsive">
          <table class="table">
           <thead>
             <tr>
               <th scope="col">Acciones Asistencia Primaria</th>
               <th scope="col">Nombre Asistencia Primaria</th>
               <th scope="col">Nombre Sub-asistencia</th>
               <th scope="col">Nombre Asistencia</th>
               <th scope="col">Acciones Asistencia</th>
               
             </tr>
           </thead>
           <tbody>
            <template v-for="asistencia in attendanceList" :key="asistencia.id_asistencia">
              <tr v-for="(asistencia, index) in asistencia.asistencias" :key="asistencia.id_asistencia">
              <td data-label="Acciones asistencia" v-if="index === 0" :rowspan="asistencia.asistencias.length">
                  <div class="icon-container">
                  <i 
                    class="fa fa-plus-circle fa-2x" 
                    style="color:skyblue" 
                    title="agregar una Asistencia" 
                    @click="addAttendance(asistencia)"
                    ></i>&nbsp;
                  </div>
                  <div class="icon-container">
                  <i 
                    class="fa fa-trash fa-2x" 
                    style="color:red" 
                    title="eliminar profesor" 
                    @click="deletePrimaryAttendanceRegistered(asistencia)"></i>
                  </div>
                </td>
                <td data-label="Asistencia Primaria" v-if="index === 0" :rowspan="asistencia.asistencias.length">{{ asistencia.asistencia_primaria }}</td>
                <td data-label="Sub-asistencia" v-if="index === 0" :rowspan="asistencia.asistencias.length">{{ asistencia.sub_asistencia }}</td>
                <td data-label="Asistencia">{{ asistencia.asistencia }}</td>
                <td data-label="Acciones Asistencia">
                  <div class="icon-container">
                  <i 
                    class="fa fa-trash fa-2x" 
                    style="color:red" 
                    title="eliminar asignatura" 
                    @click="deleteAttendanceRegistered(asistencia, profesor)"></i>
                  </div>
                </td>
              </tr>
            </template>
           </tbody>
          </table>
        </div>
      </div> -->
      <!-- agregar asitencia a privados de libertad-->
      <div v-if="isAddingPpl">
          <!--búsqueda de persona privada de libertad -->
            <div class="row my-5">
              <div class="col-md-4 mt-5">
                <label class="form-label"
                  >Búsqueda PPL:
                  <i
                    class="fas fa-info-circle"
                    title="La búsqueda deberá realizarse por el Nombre completo o Número de documento de identidad"
                  >
                  </i>
                </label>
                <input
                  type="text"
                  class="form-control fuente"
                  style="text-transform: uppercase"
                  id="dato"
                  v-model.trim="dato_busqueda_ppl"
                  @keyup.enter="searchPpl(dato_busqueda_ppl)"
                  @input="checkFieldEmpty($event, dato_busqueda_ppl, 'dato_ppl')"
                />
              </div>
              <div class="col-md-3 col-sm-12 mt-7">
                <button
                  type="button"
                  style="margin: 5px"
                  class="btn px-3"
                  :disabled="!dato_busqueda_ppl"
                  @click="searchPpl(dato_busqueda_ppl)"
                >
                  <i
                    title="Realizar búsqueda de Ppl"
                    style="font-size: 1.5em; color: Dodgerblue"
                    class="fas fa-magnifying-glass"
                  ></i>
                </button>
                <button
                  type="button"
                  style="margin: 10px"
                  class="btn px-3"
                  @click="
                    (dato_busqueda_ppl = ''),
                      (resultados_ppls = []),
                      (statePplAttendance.formData.id_persona = null)
                  "
                >
                  <i
                    title="Vaciar campo"
                    style="font-size: 1.5em; color: red"
                    class="fas fa-trash"
                  ></i>
                </button>
              </div>
            </div>
            <!-- lista de ppls -->
            <div class="row table-responsive">
              <table class="table">
                <caption v-if="resultados_ppls.length > 0" style="caption-side: top">
                  {{
                    resultados_ppls.length === 1 ? "Existe" : "Existen"
                  }}
                  {{
                    resultados_ppls.length
                  }}
                  {{
                    resultados_ppls.length === 1
                      ? "coincidencia"
                      : " posibles coincidencias"
                  }}
                </caption>
                <thead>
                  <tr >
                    <th>NOMBRE PPL</th>
                    <th>N° DOCUMENTO</th>
                    <th>RECINTO PENITENCIARIO</th>
                    <th>DELITO</th>
                    <th>SELECCIONAR</th>
                  </tr>
                </thead>
                <tbody>
                  <td v-if="resultados_ppls.length == 0 && !isLoading" colspan="8">
                    Sin datos que mostrar
                  </td>
                  <td v-else-if="resultados_ppls.length == 0 && isLoading" colspan="8">
                    Cargando...
                  </td>
                  <tr v-else v-for="dato in resultados_ppls" :key="dato.id_persona">
                    <td data-column="NOMBRE PPL">{{ dato.nombre_completo }}</td>
                    <td data-column="N° DOCUMENTO">{{ dato.nro_doc }}</td>
                    <td data-column="RECINTO">
                      {{ dato.nombre_recinto_penitenciario }}
                    </td>
                    <td data-column="DELITO">{{ dato.descripcion_delito }}</td>
                    <td data-column="SELECCIONAR">
                      <input
                        type="radio"
                        :value="dato.id_persona"
                        :id="dato.id_persona"
                        v-model="statePplAttendance.formData.id_persona"
                      />
                    </td>
                  </tr>
                </tbody>
                <!-- <span class="text-danger" v-if="!statePplAttendance.formData.id_persona">
                  Seleccione una Persona Privada de Libertad
                </span> -->
              </table>
            </div>
            <div class="row">
            <!-- ASISTENCIA PRIMARIA -->
              <div class="col-md-6 p-2">
                <label for="" required>Asistencia Principal:</label>
                <select 
                  class="form-select"
                  v-model.trim="statePplAttendance.formData.id_asistencia_principal"
                  id="asistencia_principal"
                  @change="getSubAsistenciaList(statePplAttendance.formData.id_asistencia_principal)"
                >
                  <option selected disabled>Seleccione una opción</option>
                  <option 
                    v-for="asistencia in asistenciaPrincipalList" 
                    :key="asistencia.id_asistencia_principal" 
                    :value="asistencia.id_asistencia_principal"
                  >
                    {{ asistencia.nombre_asistencia_principal }}
                  </option>
                </select>
              </div>
              <!-- SUBASISTENCIA -->
              <div class="col-md-6 p-2">
                <label for="" required>Sub-asistencia:</label>
                <select 
                  class="form-select"
                  v-model.trim="statePplAttendance.formData.id_sub_asistencia"
                  id="sub_asistencia"
                  @change="getAsistenciaList(statePplAttendance.formData.id_sub_asistencia)"
                >
                  <option selected disabled>Seleccione una opción</option>
                  <option 
                    v-for="asistencia in subAsistenciaList" 
                    :key="asistencia.id_sub_asistencia" 
                    :value="asistencia.id_sub_asistencia"
                  >
                    {{ asistencia.nombre_sub_asistencia }}
                  </option>
                </select>
              </div>
              <!-- ASISTENCIA -->
              <div class="col-md-6 p-2">
                <label for="" required>Asistencia:</label>
                <select 
                  class="form-select"
                  v-model.trim="statePplAttendance.formData.id_asistencia"
                  id="sub_asistencia"
                  :disabled="asistenciaList.length===0"
                >
                  <option selected disabled>Seleccione una opción</option>
                  <option 
                    v-for="asistencia in asistenciaList" 
                    :key="asistencia.id_asistencia" 
                    :value="asistencia.id_asistencia"
                  >
                    {{ asistencia.nombre_asistencia }}
                  </option>
                </select>
              </div>
              <div class="col-md-6 p-2">
                <label for="" required>Fecha Asistencia Psicológica:</label>
                <input 
                  type="date"
                  class="form-control"
                  v-uppercase
                  v-model.trim="statePplAttendance.formData.fecha_asistencia_psicologica"
                  :max="fecha_actual"
                >
              </div>
              <div class="row">
              <label for="" required>Conclusiones y Recomendaciones:</label>
                <textarea 
                  type="text"
                  class="form-control"
                  v-uppercase
                  v-model.trim="statePplAttendance.formData.recomendaciones"
                >
                </textarea>
              </div>
              <p class="p-2" align="right">
                <button
                  class="btn btn-danger"
                  @click="clearFormPplAttendance()"
                >
                  Limpiar
                </button>&nbsp;
                <button
                  v-if="!isLoading"
                  class="btn btn-success"
                  :disabled="!validateRegisterPplAttendanceForm"
                  @click="isEditingPpl?registerEditedPpl():registerPplAttendance()"
                >
                  {{isEditingPpl?'Editar':'Registrar'}} Ppl
                </button>
                <button
                    v-else
                    class="btn btn-primary"
                    disabled
                  >
                    Por favor espere ...
                </button>
              </p>
            </div>
      </div>
      <!-- lista asitencia a privados de libertad-->
      <div v-if="isListPplAttendance" class="row p-3 table-responsive">
      <h4>Lista de Asistencias a Ppls</h4>
        <table class="table">
          <thead>
            <tr>
              <th scope="col">N°</th>
              <th scope="col">Acciones</th>
              <th scope="col">Nombre Ppl</th>
              <th scope="col">Nombre Asistencia Principal </th>
              <th scope="col">Nombre Sub-asistencia</th>
              <th scope="col">Nombre Asistencia</th>
              <th scope="col">Fecha Asistencia Psicológica</th>
              <th scope="col">Recinto Penitenciario</th>
              <th scope="col">Departamento Recinto Penitenciario</th>
              <th scope="col">Conclusiones o Recomendaciones</th>
            </tr>
          </thead>
          <tbody>
            <td v-show="pplAttendanceList.length==0" colspan="9"> No existen registros para mostrar</td>
            <tr v-for="(ppl, index) in pplAttendanceList" :key="ppl.id_ppl_asistencia">
              <td data-label="N°">{{index+1}}</td>
              <td data-label="Acciones">
              <div class="icon-container">
               <i 
                class="fa fa-edit fa-2x" 
                style="color:skyblue" 
                title="editar"
                @click="fillEditPplAttendance(ppl)"
                ></i>&nbsp;
              </div>
              <div class="icon-container">
               <i 
                class="fa fa-trash fa-2x" 
                style="color:red" 
                title="inhabilitar"
                @click="deletePplAttendance(ppl)"></i>
              </div>
              </td>
              <td data-label="Nombre">{{ppl.nombre_completo}}</td>
              <td data-label="Asist. Primaria">{{ppl.nombre_asistencia_principal}}</td>
              <td data-label="sub-asistencia">{{ppl.nombre_sub_asistencia}}</td>
              <td data-label="Asistencia">{{ppl.nombre_asistencia}}</td>
              <td data-label="Fecha">{{ppl.fecha_asistencia_psicologica}}</td>
              <td data-label="Recinto">{{ppl.nombre_recinto_penitenciario}}</td>
              <td data-label="Departamento">{{ppl.departamento}}</td>
              <td data-label="Conclusiones">{{ppl.recomendaciones}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div  v-if="isChart" class="row">
     <div class="card-body col-6">
      <!--begin::Chart-->
      <apexchart
        
        type="area"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>
    <div class="card-body col-6">
      <!--begin::Chart-->
      <apexchart type="pie" :options="chartOptionspie" :series="seriespie"></apexchart>
    </div>
     </div>
  <loading
      v-model:active="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      :height="100"
      :width="100"
  ></loading>
  </template>
  <script>
import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  reactive,
  ref,
  inject,
} from "vue";
import Loading from "vue-loading-overlay";
import user from "@/user/composables/useUser";
import useAuth from "@/auth/composables/useAuth";
import filiation from "@/filiation/composables/useFiliation";
import visits from "@/visits/composables/useVisits";
import modPsychologic from "@/mod_psychologic/composables/useModPsychologic";
import es from "apexcharts/dist/locales/es.json"
import Swal from "sweetalert2/dist/sweetalert2.min.js";
export default defineComponent({
  name: "registerPsychologicForm",
   components: {
        Loading,
        },
  props: {
    nombre_ruta: String,
  },
  setup(props, context){
    const dato_busqueda_ppl =ref();
    const resultados_ppls = ref([]);
    const isLoading = ref(false);
    const departmentsList = ref([]);
    const nameNavbar = computed(() => props.nombre_ruta);
    const isChart = ref(true);
    const isAddingPsychologicattendance = ref(false);
    const isListTeachers = ref(false);
    const isAddingPpl = ref(false);
    const isListPplAttendance = ref(false);
    const isCourse = ref(false);
    const isInstitution = ref(false); 
    const isEditingInstitution = ref(false);
    const isEditingPpl = ref(false);
    const isEditingCourse = ref(false);
    const isAddingOtherAttendance =ref(false);
    const dato_busqueda = ref(null);
    const asistenciaPrincipalList =ref([]);
    const subAsistenciaList =ref([]);
    const asistenciaList = ref([]);
    const institutionsList =ref([]);
    const coursesList = ref([]);
    const prisionsList =ref([]);
    const attendanceList =ref([]);
    const pplAttendanceList =ref([]);
    const fecha_actual = computed(()=>{
      let today = new Date();
      let dd = today.getDate();
      let mm = today.getMonth()+1; //January is 0!
      let yyyy = today.getFullYear();
      if(dd<10){
              dd='0'+dd
      } 
       if(mm<10){
             mm='0'+mm
       } 

          return today = yyyy+'-'+mm+'-'+dd; 
    })

    const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
    });
    let chartOptions = ref({
      chart: {
        id: "vuechart",
        locales: [es],
        defaultLocale: "es",
        toolbar: {
          show: true,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: true,
            selection: false,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: false,
            reset: true | '<img src="/static/icons/reset.png" width="20">',
            customIcons: [],
          },
          export: {
            csv: {
              filename: "Sirep_report",
              columnDelimiter: ":",
              headerCategory: "category",
              headerValue: "value",
              dateFormatter(timestamp) {
                return new Date(timestamp).toDateString();
              },
            },
            svg: {
              filename: "Sirep_report",
            },
            png: {
              filename: "Sirep_report",
            },
          },
          autoSelected: "zoom",
        },
      },
      xaxis: {
        categories: [],
        labels: {
          show: true,
          rotate: -800,
          rotateAlways: true,
          hideOverlappingLabels: false,
          showDuplicates: false,
          trim: true,
          minHeight: 200,
          maxHeight: 200,
          style: {
            colors: [],
            fontSize: "12px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: 200,
            cssClass: "apexcharts-xaxis-label",
          },
          offsetX: 0,
          offsetY: 0,
        },
      },
    });
    let series = ref([
      {
        name: "Personas privadas de libertad",
        data: [],
      },
    ]);
    let seriespie= ref([44, 55, 13, 43, 22]);
    const chartOptionspie= ref({
            chart: {
              width: 380,
              type: 'pie',
            }});
    
    const {
      // searchSegip,
      nameDepartments,
      // nameProvinces,
      // namePenitentiaries,
      // nameRoles,
      // createUser,
      // infoUser,
      // infoRolesUser,
      // infoPasswordUser,
      // updateUser,
      // sendMail,
    } = user();
    const {
      // rol,
      // nombre_recinto_penitenciario,
      departamento_centro_penitenciario,
      // departamento_supervisar,
       id_recinto,
    } = useAuth();
    const { valueToSearch } = visits();
    const {prisionNames} = filiation();
    const {
           saveAttendance,
           getAsistenciaPrincipal, 
           getSubAsistencia,
           getAsistencia,
           savePplAttendance,
           getPplAttendance,



    
           deleteInstitution,
           deleteCourse,

           
           getTeachers,
           deleteattendanceById,
           deleteattendanceCourseById,

           getStudents,
           editStudent,
           deletePplattendanceById
           
           } = modPsychologic();
    const searchPpl = async (value) => {
        isLoading.value = true;
        const { data } = await valueToSearch(value.toUpperCase());
        if (!data.ok) {
          Toast.fire({
            icon: "info",
            title: "No existen coincidencias con los datos ingresados",
          });
          isLoading.value = false;
        } else {
            Toast.fire({
              icon: "success",
              title: "La búsqueda retornó resultados!",
            });
          isLoading.value = false;
          resultados_ppls.value = data.respuesta;
        }
      };
// verificar si campos de busqueda estan vacios
    const checkFieldEmpty = (dato, type) => {
      if (dato === "" && type === "dato_ppl") {
        statePplAttendance.formData.id_persona = null;
        resultados_ppls.value = [];
      }
    };      
    const listPrisions = async () => {
      const { data } = await prisionNames();
      if (departamento_centro_penitenciario.value!=='NACIONAL') {
         const result = data.filter( value => value.id_recinto_penitenciario===id_recinto.value)
         prisionsList.value = result;        
      } else {
        prisionsList.value = data;
      }
    };
    const listNameDepartments = async () => {
      const { data } = await nameDepartments();
      departmentsList.value = data;
    };
    const capitalize = (word) => {
      if (!word) return ''; // Manejar el caso de una cadena vacía
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    };
    


    const getAsistenciaPrimariaList = async () =>{
      const { data } = await getAsistenciaPrincipal();
        asistenciaPrincipalList.value = data;
    };
    const getSubAsistenciaList = async (id_asistencia_principal) =>{
      const { data } = await getSubAsistencia(id_asistencia_principal);
        subAsistenciaList.value = data;
    };
    const getAsistenciaList = async (id_sub_asistencia) =>{
      const { data } = await getAsistencia(id_sub_asistencia);
        asistenciaList.value = data;
    };


    const fillEditInstitution = (id) =>{
      isEditingInstitution.value = true;
      const selectElement = document.getElementById('area_formacion_institucion');
      if (selectElement) {
        selectElement.focus();; 
      }
      const result = institutionsList.value.filter((value)=> value.id_institucion === id)
        // stateInstitution.formData.id_institucion=result[0].id_institucion,
        // stateInstitution.formData.id_asistencia_primaria=result[0].cod_area_formacion,
        // stateInstitution.formData.institucion=result[0].nombre_institucion,
        // stateInstitution.formData.departamento=result[0].departamento
    }
    const deleteInstitutionById = async (institucion) =>{
      Swal.fire({
        title: `¿Está seguro de eliminar a ${institucion.nombre_institucion} del departamento de ${institucion.departamento}?`,
        text: "Esta acción no podrá ser revertida",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "¡Si, eliminar!",
        cancelButtonText: "¡No, retornar!",
        reverseButtons: true
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
              isLoading.value=true;
              const { data } = await deleteInstitution(institucion.id_institucion);
              if (data.ok) {
                  Swal.fire({
                    title: "¡Realizado!",
                    text: `La institución ${institucion.nombre_institucion} de ${institucion.departamento} fue eliminada satisfactoriamente`,
                    icon: "success",
                    buttonsStyling: false,
                    confirmButtonText: "Continuar",
                    customClass: {
                      confirmButton: "btn fw-bold btn-light-primary",
                    },
                  });
                  // router.push({name:"listDeprivedLibertybyPrisons"})
              }
          } catch (error) {   
            console.log(error);
            Swal.fire({
                    title: "¡Error!",
                    text: `La institución no pudo ser eliminada`,
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: "Continuar",
                    customClass: {
                      confirmButton: "btn fw-bold btn-light-primary",
                    },
                  });       
          }finally{
            isLoading.value=false
          }
        }
      });
    }
    const attendance = reactive ({
        asistencia_principal:"",
    })
    const statePsychologicAttendance = reactive([{
        id_asistencia:0,
        asistencia_primaria:"",
        sub_asistencia:"",
        asistencias:[]
    }
    ]);
    const clearFormAttendanceForm = () => {
        attendance.asistencia_principal=""
    }
    const addAttendanceToArray = () => {
      statePsychologicAttendance[0].asistencias.push({ ...attendance });
       clearFormAttendanceForm();
    };
    const deleteattendance = (index) => {
      statePsychologicAttendance[0].asistencias.splice(index, 1);
     };
    const editAttendance = (value, index) => {
      for (let i in statePsychologicAttendance[0].asistencias) {
        if (i == index) {
          attendance.asistencia_principal = statePsychologicAttendance[0].asistencias[i].asistencia_principal;
          break;
        }
      }
      deleteattendance(index);
    };
    const validateregisterAttendanceForm = () =>{
      if(!statePsychologicAttendance[0].asistencia_primaria || !statePsychologicAttendance[0].sub_asistencia || statePsychologicAttendance[0].asistencias.length==0){
        return {ok:false,message:"El nombre de la asistencia primaria y sub-asistencia a al menos una asistencia son requeridos" }
      }else{
      return{ok:true}
      }
    }
    const registerAttendance = async() => {
    const {ok, message} = validateregisterAttendanceForm()
      if(!ok){
        alert(`${message}`)
      }else{
        try {
            isLoading.value=true;
            const { data } = await saveAttendance(statePsychologicAttendance[0]);
            if (data.ok) {
                Swal.fire({
                  title: "¡Realizado!",
                  text: `La asistencia fue añadida exitosamente`,
                  icon: "success",
                  buttonsStyling: false,
                  confirmButtonText: "Continuar",
                  customClass: {
                    confirmButton: "btn fw-bold btn-light-primary",
                  },
                });
                statePsychologicAttendance[0].asistencia_primaria='';
                statePsychologicAttendance[0].sub_asistencia='';
                statePsychologicAttendance[0].asistencias=[];
            }
        } catch (error) {   
          console.log(error);
          Swal.fire({
                  title: "¡Error!",
                  text: `El registro no pudo ser realizado`,
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "Continuar",
                  customClass: {
                    confirmButton: "btn fw-bold btn-light-primary",
                  },
                });       
        }finally{
          isLoading.value=false;
          isAddingOtherAttendance.value=false;
        }
      }
    }
    const getattendanceList = async () =>{
      const { data } = await getTeachers(id_recinto.value);
      attendanceList.value = data;
    }
    const addAttendance = async(profesor)=>{
      isAddingPsychologicattendance.value=true;
      isListTeachers.value=false;
      isAddingOtherAttendance.value=true;
      statePsychologicAttendance[0].asistencia_primaria=profesor.asistencia_primaria;
      statePsychologicAttendance[0].sub_asistencia=profesor.sub_asistencia;
    }
    const deletePrimaryAttendanceRegistered = async (profesor) =>{
      Swal.fire({
        title: `¿Está seguro de eliminar a ${profesor.nombre_completo} y todas sus asignaturas?`,
        text: "Esta acción no podrá ser revertida",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "¡Si, eliminar!",
        cancelButtonText: "¡No, retornar!",
        reverseButtons: true
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
              isLoading.value=true;
              const { data } = await deleteattendanceById(profesor.id_profesor);
              if (data.ok) {
                  Swal.fire({
                    title: "¡Realizado!",
                    text: `La eliminación fue realizada con éxito`,
                    icon: "success",
                    buttonsStyling: false,
                    confirmButtonText: "Continuar",
                    customClass: {
                      confirmButton: "btn fw-bold btn-light-primary",
                    },
                  });
                  getattendanceList()
                  // router.push({name:"listDeprivedLibertybyPrisons"})
              }
          } catch (error) {   
            console.log(error);
            Swal.fire({
                    title: "¡Error!",
                    text: `La institución no pudo ser eliminada`,
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: "Continuar",
                    customClass: {
                      confirmButton: "btn fw-bold btn-light-primary",
                    },
                  });       
          }finally{
            isLoading.value=false
          }
        }
      });
    }
    const deleteAttendanceRegistered = async (asignatura, profesor) =>{
      Swal.fire({
        title: `¿Está seguro de eliminar la asignatura ${asignatura.nombre_asignatura} del profesor ${profesor.nombre_completo}?`,
        text: "Esta acción no podrá ser revertida",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "¡Si, eliminar!",
        cancelButtonText: "¡No, retornar!",
        reverseButtons: true
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
              isLoading.value=true;
              const { data } = await deleteattendanceCourseById(asignatura.id_profesor_asignatura, asignatura.cod_profesor);
              if (data.ok) {
                  Swal.fire({
                    title: "¡Realizado!",
                    text: `La eliminación fue realizada con éxito`,
                    icon: "success",
                    buttonsStyling: false,
                    confirmButtonText: "Continuar",
                    customClass: {
                      confirmButton: "btn fw-bold btn-light-primary",
                    },
                  });
                  getattendanceList()
                  // router.push({name:"listDeprivedLibertybyPrisons"})
              }
          } catch (error) {   
            console.log(error);
            Swal.fire({
                    title: "¡Error!",
                    text: `La institución no pudo ser eliminada`,
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: "Continuar",
                    customClass: {
                      confirmButton: "btn fw-bold btn-light-primary",
                    },
                  });       
          }finally{
            isLoading.value=false
          }
        }
      });
    }



    







    

    const statePplAttendance = reactive({
      formData: {
        id_ppl_asistencia:0,
        id_persona:"",
        id_asistencia_principal:"",
        id_sub_asistencia:"",
        id_asistencia:"",
        fecha_asistencia_psicologica:"",
        recomendaciones:""
      },
    });
    const addPplAttendance = () =>{
      isAddingPpl.value = !isAddingPpl.value
      isListPplAttendance.value = false;
      if(isChart.value == true){
        isChart.value = false 
      }
      if (!isAddingPpl.value) {
        isChart.value = true
      }
    }
    const clearFormPplAttendance = () => {
        statePplAttendance.formData.id_ppl_asistencia=0,
        statePplAttendance.formData.id_persona="",
        statePplAttendance.formData.id_asistencia="",
        statePplAttendance.formData.id_sub_asistencia="",
        statePplAttendance.formData.id_asistencia_principal=""
        statePplAttendance.formData.recomendaciones=""
        resultados_ppls.value=[]
        dato_busqueda_ppl.value=""
    }
    const listPplAttendance = () => {
      isListPplAttendance.value = !isListPplAttendance.value
      isAddingPpl.value = false;
      getPplAttendanceList()
      if(isChart.value == true){
        isChart.value = false 
      }
      if (!isListPplAttendance.value) {
        isChart.value = true
      }
    }
    const validateRegisterPplAttendanceForm = computed(()=>{
      return true
      // TODO validar
      // if (attendanceList.length==0) {
        
      // }
      // if ( (attendanceList.length==0 && (!statePplAttendance.formData.id_persona || !statePplAttendance.formData.id_asistencia_principal || !statePplAttendance.formData.id_sub_asistencia)) || 
      //       (subAsistenciaList.length==0 && (!statePplAttendance.formData.id_persona || !statePplAttendance.formData.id_asistencia_principal))) {
      //   return false
      // }else{
      //   return true
      // }
    })
    const registerPplAttendance = async() =>{
      if (!validateRegisterPplAttendanceForm) {
        alert("Todos los campos deben estar completos para el registro")
      }else{
        try {
            isLoading.value=true;
            const { data } = await savePplAttendance(statePplAttendance.formData);
            if (data.ok) {
                Swal.fire({
                  title: "¡Realizado!",
                  text: `El registro fue realizado correctamente`,
                  icon: "success",
                  buttonsStyling: false,
                  confirmButtonText: "Continuar",
                  customClass: {
                    confirmButton: "btn fw-bold btn-light-primary",
                  },
                });
                clearFormPplAttendance();
                isListPplAttendance.value=true;
                isAddingPpl.value=false;
                await getPplAttendanceList();
            }
        } catch (error) {   
          console.log(error);
          Swal.fire({
                  title: "¡Error!",
                  text: `El registro no pudo ser realizado`,
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "Continuar",
                  customClass: {
                    confirmButton: "btn fw-bold btn-light-primary",
                  },
                });       
        }finally{
          isLoading.value=false
        }
      }
    }
    const getPplAttendanceList = async () =>{
      const { data } = await getPplAttendance(id_recinto.value);
      // if (stateCourse.formData.id_recinto_penitenciario) {
      // attendanceList.value = data.filter(value =>{value.cod_recinto_penitenciario==id_recinto.value})
      // }
      pplAttendanceList.value = data;
    }
    const fillEditPplAttendance= async(id) =>{
      isAddingPpl.value=true;
      isListPplAttendance.value=false;
      isEditingPpl.value = true;
      const selectElement = document.getElementById('dato');
      if (selectElement) {
        selectElement.focus();
      }
      const result = pplAttendanceList.value.filter((value)=> value.cod_persona === id.cod_persona)
        statePplAttendance.formData.id_estudiante_asignatura=result[0].id_estudiante_asignatura,
        statePplAttendance.formData.id_persona=result[0].cod_persona,
        statePplAttendance.formData.id_asistencia_primaria=result[0].cod_area_formacion,
        statePplAttendance.formData.id_asignatura=result[0].cod_asignatura;
        await searchPpl(result[0].nombre_completo)
    }
    const registerEditedPpl = async() =>{
      if (!validateRegisterPplAttendanceForm) {
        alert("Todos los campos deben estar completos para el registro")
      }else{
        try {
            isLoading.value=true;
            const { data } = await editStudent(statePplAttendance.formData);
            if (data.ok) {
                Swal.fire({
                  title: "¡Realizado!",
                  text: `El estudiante fue editado correctamente`,
                  icon: "success",
                  buttonsStyling: false,
                  confirmButtonText: "Continuar",
                  customClass: {
                    confirmButton: "btn fw-bold btn-light-primary",
                  },
                });
                clearFormPplAttendance()
                isListPplAttendance.value=true;
                isAddingPpl.value=false;
                await getPplAttendanceList()
                
            }
        } catch (error) {   
          console.log(error);
          Swal.fire({
                  title: "¡Error!",
                  text: `El estudiante no fue editado correctamente`,
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "Continuar",
                  customClass: {
                    confirmButton: "btn fw-bold btn-light-primary",
                  },
                });       
        }finally{
          isLoading.value=false
        }
      }
    }
    const deletePplAttendance = async (ppl) =>{
        Swal.fire({
          title: `¿Está seguro de eliminar a ${ppl.nombre_completo}?`,
          text: "Esta acción no podrá ser revertida",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "¡Si, eliminar!",
          cancelButtonText: "¡No, retornar!",
          reverseButtons: true
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
                isLoading.value=true;
                const { data } = await deletePplattendanceById(ppl.id_estudiante_asignatura);
                if (data.ok) {
                    Swal.fire({
                      title: "¡Realizado!",
                      text: `La eliminación fue realizada con éxito`,
                      icon: "success",
                      buttonsStyling: false,
                      confirmButtonText: "Continuar",
                      customClass: {
                        confirmButton: "btn fw-bold btn-light-primary",
                      },
                    });
                    getPplAttendanceList()
                }
            } catch (error) {   
              console.log(error);
              Swal.fire({
                      title: "¡Error!",
                      text: `La institución no pudo ser eliminada`,
                      icon: "error",
                      buttonsStyling: false,
                      confirmButtonText: "Continuar",
                      customClass: {
                        confirmButton: "btn fw-bold btn-light-primary",
                      },
                    });       
            }finally{
              isLoading.value=false
            }
          }
        });
    }
    onMounted(() => {
        listNameDepartments();
        getAsistenciaPrimariaList();
        listPrisions();
        // setCurrentPageBreadcrumbs(`${title.value} de Restricción de Visitante`, ["Visitas"]);
      });
    return{
      fecha_actual,
      dato_busqueda_ppl,
      searchPpl,
      checkFieldEmpty,
      resultados_ppls,

      isLoading,
      capitalize,
      departmentsList,
      prisionsList,
      attendanceList,
      isAddingOtherAttendance,

      getSubAsistenciaList,
      subAsistenciaList,
      getAsistenciaList,
      asistenciaList,

      

      asistenciaPrincipalList, 
      departamento_centro_penitenciario,
      id_recinto,
      institutionsList,
      fillEditInstitution,
      deleteInstitutionById,

      coursesList,
      

      nameNavbar,
      isAddingPsychologicattendance,
      statePsychologicAttendance,
      attendance,
      clearFormAttendanceForm,
      isListTeachers,
      addAttendanceToArray,
      editAttendance,
      deleteattendance,
      registerAttendance,
      addAttendance,
      deletePrimaryAttendanceRegistered,
      deleteAttendanceRegistered,


      isAddingPpl,
      statePplAttendance,
      addPplAttendance,
      clearFormPplAttendance,
      listPplAttendance,
      isListPplAttendance,
      registerPplAttendance,
      validateRegisterPplAttendanceForm,
      pplAttendanceList,
      fillEditPplAttendance,
      registerEditedPpl,
      deletePplAttendance,



      dato_busqueda,

      isEditingPpl,

      isCourse,
      isEditingCourse,

      isInstitution,
      isEditingInstitution,




      isChart,   
      chartOptions, 
      series,
      chartOptionspie,
      seriespie,


    }
  },
  directives: {
    // transform input to uppercase with v-uppercase
    uppercase: {
      updated: function (el) {
        el.value = el.value.toUpperCase();
        el.dispatchEvent(new Event("input"));
      },
    },
  }
})
</script>
<style scoped>
table   {
  width: 100%;
  border-collapse: collapse;
}

.table td,
.table th {
  padding: 12px 15px;
  border: 1px solid #ddd;
  text-align: center;
  font-size: 13px;
}
.table th {
  background-color: #92c9e6;
  color: #ffffff;
}

.table tbody tr:nth-child(even) {
  background-color: #d1e8f5;
}
.icon-container {
  display: inline-block;
  padding-right: 5px;
  cursor: pointer;
}
.icon-container i {
  font-size: 24px; /* Tamaño original del icono */
  transition: transform 0.3s ease; /* Transición suave */
}

.icon-container i:hover {
  transform: scale(1.2); /* Aumentar el tamaño del icono al hacer hover */
}
@media (max-width: 500px) {
  .table thead {
    display: none;
  }

  .table,
  .table tbody,
  .table tr,
  .table td {
    display: block;
    width: 100%;
  }
  .table tr {
    margin-bottom: 15px;
  }
  .table td {
    padding-left: 50%;
    text-align: left;
    position: relative;
  }
  .table td::before {
    content: attr(data-label);
    position: absolute;
    left: 0;
    width: 50%;
    padding-left: 15px;
    font-size: 15px;
    font-weight: bold;
    text-align: left;
  }
}
.cursor_pointer {
  cursor: pointer;
}
</style>